<template>
  <NuxtLink
    :to="{name: 'language-modelos-name-photo', params: {name: slug}, query: {part : (index? 3 : 4)}}"
  >
    <div class="model-list__item">
      <div class="model-list__image">
        <picture>
          <img
            :class="opac"
            :src="image"
            :alt="imageAltText || name"
            width="496"
            height="364"
            loading="lazy"
          />
        </picture>
      </div>
      <div class="model-list__info">
        <h3 class="model-list__title" v-text="name"></h3>
        <a :href="`/${route.params.language}/modelos/${slug}`" class="link">
          {{ translate.seePhotoShoot }} <i class="icon-arrow-right"></i>
        </a>
      </div>
      <div v-if="!isMobile()" style="height: 20px">&nbsp;</div>
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import { isMobile } from '~/shared/utils/mobile';
const route = useRoute();

const props = defineProps(["mobileImage", "image", "name", "slug", "index", "imageAltText"]);
const translate = computed(() =>
  route.params.language == "pt-br" ? legends.portugues : legends.ingles
);

const legends = {
  portugues: {
    seePhotoShoot: "Veja o ensaio",
  },
  ingles: {
    seePhotoShoot: "Show essay",
  },
};
const opac = ref("opacity-0");

onMounted(() => {
  opac.value = "opacity-1";
});
</script>

<style scoped></style>
